import Vue from 'vue'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'

import VueRouter from 'vue-router'
import store from './vuex/store'
import routes from './routes'
import util from './common/util'
import PicUpload from './components/PicUpload.vue'
import PicSamllUpload from './components/PicSmallUpload.vue'
import DocUpload from './components/DocUpload.vue'
import PicCardUpload from './components/PicCardUpload.vue'
import Select from './components/Select.vue'
import Button from './components/Button.vue'
import DataPicker from './components/DataPicker.vue'
import Cascader from './components/Cascader.vue'
import BaseList from './pages/BaseList.vue'


//import Mock from './mock';
//Mock.bootstrap();

//全局变量统一在此定义
global.debug = true
if (process.env.NODE_ENV == 'development') {
  global.serverHost = "http://localhost:8085/"
}else{
  if(window.location.port) {
      global.serverHost = window.location.protocol + "//" + window.location.hostname + ":"+window.location.port+"/"
  }
  else{
      global.serverHost =  window.location.protocol + "//" + window.location.hostname+"/"
  }
}
//不带https的host,http
global.serverHost_http = global.serverHost.replace("https://","http://")

global.bus = new Vue()
global.user = null
global.roles = null
global.allRoutes = null
global.Module=null
global.nowPath = ""
global.sysParam = {}
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.use(VueRouter)

//注册全局组件
Vue.component("sy-pic-upload",PicUpload)
Vue.component("sy-picsmall-upload",PicSamllUpload)
Vue.component("sy-doc-upload",DocUpload)
Vue.component("sy-card-upload",PicCardUpload)
Vue.component("sy-baselist",BaseList)
Vue.component("sy-select",Select)
Vue.component("sy-button",Button)
Vue.component("sy-dataPicker",DataPicker)
Vue.component("sy-cascader",Cascader)


Vue.filter("formatDate", function(value) {   //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  return util.date.format(value,"yyyy-MM-dd");
});

Vue.filter("formatDate2", function(value) {   //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  return util.date.format(value,"yyyy-MM-dd hh:mm:ss");
});

function routerMap(item) {
  if (item.componentPath) {
    if(item.componentPath.indexOf("http")==0){
      //链接
    }else {
      item.component = resolve => require(["./pages/" + item.componentPath], resolve) //动态加载
    }
  }
  if(item.children){
    item.children.map(routerMap)
  }
  return item
}
const router = new VueRouter()
util.get("server/system/Main.ashx?cmd=Init&r="+Math.random(),{},null,result=> {
  global.sysParam =  util.date.formatObj(result.sysParam)
  global.user = result.user
  global.topUser = result.topUser
  global.roles = result.roles
  global.allRoutes = result.menu.concat(routes).map(routerMap)
  global.Module = result.module
  global.upgrade = result.upgrade
  util.handleAuthority(result.authority)
  //global.user && util.handleAuthority2(global.user.FAuths)
  router.addRoutes(global.allRoutes)

  if(global.sysParam.loginPic){
      document.body.style.background = "url('" + global.serverHost + "upload/"+ global.sysParam.loginPic + "')"
  }else{
      document.body.style.background = "url(./assets/bg4.jpg)"
  }
  document.title=global.sysParam.systemName
  
  init();
})

//心跳包
setInterval(()=>{
    util.get("Portal.ashx?cmd=Ticket")
  },
  5*1000*60)

/*
setInterval(()=>{
    if(global.user!=null) {
      global.bus.$emit('RefreshMsgCount')
    }
  },
  1000*30)
*/

function init() {
  router.beforeEach((to, from, next) => {
    NProgress.start()
    if (to.path == '/login') {
      global.user = null
    }
    if (!global.user && to.path != '/login') {
      next({ path: '/login' })
    } else {
      //判断查询权限
      global.nowPath = to.path
      if(util.hasAuth("view")){
        next()
      }else{
        next({ path: '/login' })
      }
    }
  })

  router.afterEach(() => {
    NProgress.done()
  })

  //不必在全局注册每个组件。通过使用组件实例选项注册，可以使组件仅在另一个实例/组件的作用域中可用：
  global.vueRef = new Vue({
    el: '#app',
    template: '<App></App>',
    router,
    store,
    components: {App: App }
  })
}






// WEBPACK FOOTER //
// ./src/main.js